module.exports = __webpack_public_path__ + "k-icons.1622491730698.svg";